/**
 * Sparkline module — worksheet mini-charts.
 *
 * Sparklines are rendered as `x14:sparklineGroups` inside the worksheet's
 * extLst. They are distinct from chart objects (which live in chartN.xml).
 */
export * from "./sparkline";
